import { formatBuildingShift } from "@senciamatch/frontend/libs/getJapaneseDayOfWeek";
import type { SimpleEditSession } from "@senciamatch/frontend/stores/useWorkShiftEditStore";

interface ShiftConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  session: SimpleEditSession | null;
  sessionIndex: number;
  isLoading: boolean;
}

export const ShiftConfirmationModal: React.FC<ShiftConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  session,
  sessionIndex,
  isLoading,
}) => {
  if (!show || !session) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full max-h-[80vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">シフト変更案 {sessionIndex + 1} の確認</h2>

        <div className="mb-6">
          <p className="text-sm text-gray-600 mb-4">以下の変更を確定してもよろしいですか？</p>

          {session.changes.length > 0 ? (
            <div className="space-y-2 max-h-60 overflow-y-auto">
              <div className="text-sm font-medium text-gray-700">変更内容 ({session.changes.length}件)</div>
              {session.changes.map((change, index) => (
                <div
                  key={`${change.workShiftId}-${index}`}
                  className="text-xs bg-gray-100 rounded p-3 border border-gray-200"
                >
                  <div className="font-medium text-gray-700">
                    {formatBuildingShift({
                      year: change.workShiftInfo.year,
                      month: change.workShiftInfo.month,
                      day: change.workShiftInfo.day,
                      buildingName: change.workShiftInfo.buildingName,
                      startHour: change.workShiftInfo.startHour ?? 0,
                      startMinute: change.workShiftInfo.startMinute ?? 0,
                      endHour: change.workShiftInfo.endHour ?? 0,
                      endMinute: change.workShiftInfo.endMinute ?? 0,
                    })}
                  </div>
                  <div className="mt-2">
                    <span className="text-gray-600">{change.originalStaffName || "未割当"}</span>
                    <span className="mx-2 text-gray-400">→</span>
                    <span className="text-green-600 font-bold">{change.newStaffName}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">変更がありません</p>
          )}
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 disabled:opacity-50"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading || session.changes.length === 0}
            className="px-4 py-2 text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50"
          >
            {isLoading ? "処理中..." : "確定"}
          </button>
        </div>
      </div>
    </div>
  );
};
